import { useLocation } from "react-router-dom";
import { getModulePath, LEAGUE_MODULE_NAMES } from "@leagueplatform/core";
import { LazySchedulingFlowOverlay } from "components/lazy-routes.component";

// CareFinderRoutes and AppointmentSchedulingRoutes mount the overlay
// themselves, so rendering the app-root one on their paths puts two
// overlays in the tree against a single store — both open, both fetching
// the flow shell.
export const SchedulingFlowOverlayHost = () => {
  const { pathname } = useLocation();
  const sdkRoutesOwnOverlay = [
    getModulePath(LEAGUE_MODULE_NAMES.careFinder),
    getModulePath(LEAGUE_MODULE_NAMES.appointmentScheduling),
  ].some((modulePath) => pathname.startsWith(modulePath));

  return sdkRoutesOwnOverlay ? null : <LazySchedulingFlowOverlay />;
};
